export default __webpack_public_path__ + "static/media/accident.49ef47ca.gif";